// shared/application/validarImagenes.js  (valida archivos por contenido antes de encolarlos). Sin JSX ni Swal.
import { validarImagen } from '../domain/media';
import { archivoRepository } from '../infrastructure/archivo';

/**
 * Lee la cabecera de cada archivo y los separa en { validos: File[], rechazados: [{ name, reason }] }.
 * `archivo` inyectable ({ leerCabecera(file) -> Uint8Array }) para pruebas.
 */
export const validarImagenes = async (files, archivo = archivoRepository) => {
  const lista = Array.from(files || []);
  const resultados = await Promise.all(lista.map(async file => validarImagen(file, await archivo.leerCabecera(file))));
  const validos = [];
  const rechazados = [];
  lista.forEach((file, i) => {
    if (resultados[i].ok) validos.push(file);
    else rechazados.push({ name: file.name, reason: resultados[i].reason });
  });
  return { validos, rechazados };
};
